import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for delete strategies 
export const DeleteStrategies = createSlice({
  name: "DeleteStrategies",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    delete_Strategies: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_delete_Strategies: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
      state.switchResponse = true;

    },
    failure_api_call_delete_Strategies: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.switchResponse = true;

    },
    delete_Strategies_is_success: (state, action) => {
      state.isSuccess = false;
    },
    false_switchdeletestrategies_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default DeleteStrategies.reducer;
export const {
  delete_Strategies,
  success_api_call_delete_Strategies,
  failure_api_call_delete_Strategies,
  delete_Strategies_is_success,
  false_switchdeletestrategies_response
} = DeleteStrategies.actions;
